import { UserMissionCategoryPopulated } from '@gamiphy/bl/mission/types';
import {
  CategoriesKeys, CategoriesTypes, MissionActions, UserMissionsStatuses,
} from '@gamiphy/bl/mission/enums';
import { SINGLE_MISSION_CATEGORIES } from '@gamiphy/bl/mission/constants';

export const isMissionActive = (mission: UserMissionCategoryPopulated): boolean => mission.status === UserMissionsStatuses.active;

export const isMissionCategorySequential = (mission: UserMissionCategoryPopulated): boolean => mission.mission.category.type === CategoriesTypes.sequential;

export const isTitleEditable = (categoryKey: CategoriesKeys): boolean => {
  switch (categoryKey) {
    case CategoriesKeys.visitPage:
      return true;
    default:
      return false;
  }
};

export const isCtaRequired = (categoryKey: CategoriesKeys): boolean => {
  switch (categoryKey) {
    case CategoriesKeys.social:
    case CategoriesKeys.facebook:
    case CategoriesKeys.tiktok:
    case CategoriesKeys.x:
    case CategoriesKeys.instagram:
    case CategoriesKeys.birthday:
    case CategoriesKeys.visitPage:
    case CategoriesKeys.specificProduct:
      return true;
    default:
      return false;
  }
};

export const getCtaAction = (categoryKey: CategoriesKeys): MissionActions => {
  switch (categoryKey) {
    case CategoriesKeys.basketSize:
    case CategoriesKeys.purchase:
    case CategoriesKeys.discountCrusher:
      return MissionActions.goToUrl;
    case CategoriesKeys.social:
      return MissionActions.connectToFacebook;
    case CategoriesKeys.facebook:
    case CategoriesKeys.instagram:
    case CategoriesKeys.tiktok:
    case CategoriesKeys.x:
      return MissionActions.openPopupAndMarkDone;
    default:
      return MissionActions.goToUrl;
  }
};

export const isSingleMissionCategory = (categoryKey: CategoriesKeys): boolean => SINGLE_MISSION_CATEGORIES.includes(categoryKey);

export const isUrlCtaRequired = (missionAction: MissionActions): boolean => {
  switch (missionAction) {
    case MissionActions.goToUrl:
    case MissionActions.openPopupAndMarkDone:
      return true;
    default:
      return false;
  }
};
